/**
 * Maps RingsDB legacy `pack_name` values to FFG revised / repackaged products.
 *
 * Sources: FFG "Retelling the Tale" / "Evil Reawakened" announcements; Card Talk FAQ
 * (2024); BGG LotR:LCG Releases by Date. Only cycles FFG repackaged are mapped.
 */

/** @type {Record<string, string>} */
const LEGACY_PACK_TO_REVISED = {
  // Core
  "Core Set": "Revised Core Set",
  "Revised Core Set (Campaign Only)": "Revised Core Set",

  // Angmar Awakened — The Lost Realm deluxe + 6 adventure packs
  "The Lost Realm": "Angmar Awakened Hero Expansion",
  "The Wastes of Eriador": "Angmar Awakened Hero Expansion",
  "Escape from Mount Gram": "Angmar Awakened Hero Expansion",
  "Across the Ettenmoors": "Angmar Awakened Hero Expansion",
  "The Treachery of Rhudaur": "Angmar Awakened Hero Expansion",
  "The Battle of Carn Dûm": "Angmar Awakened Hero Expansion",
  "The Dread Realm": "Angmar Awakened Hero Expansion",
  "Angmar Awakened Campaign Expansion": "Angmar Awakened Hero Expansion",

  // Dream-chaser — The Grey Havens deluxe + 6 adventure packs
  "The Grey Havens": "Dream-chaser Hero Expansion",
  "Flight of the Stormcaller": "Dream-chaser Hero Expansion",
  "The Thing in the Depths": "Dream-chaser Hero Expansion",
  "Temple of the Deceived": "Dream-chaser Hero Expansion",
  "The Drowned Ruins": "Dream-chaser Hero Expansion",
  "A Storm on Cobas Haven": "Dream-chaser Hero Expansion",
  "The City of Corsairs": "Dream-chaser Hero Expansion",
  "Dream-chaser Campaign Expansion": "Dream-chaser Hero Expansion",

  // Ered Mithrin — The Wilds of Rhovanion deluxe + 6 adventure packs
  "The Wilds of Rhovanion": "Ered Mithrin Hero Expansion",
  "The Withered Heath": "Ered Mithrin Hero Expansion",
  "Roam Across Rhovanion": "Ered Mithrin Hero Expansion",
  "Fire in the Night": "Ered Mithrin Hero Expansion",
  "The Ghost of Framsburg": "Ered Mithrin Hero Expansion",
  "Mount Gundabad": "Ered Mithrin Hero Expansion",
  "The Fate of Wilderland": "Ered Mithrin Hero Expansion",
  "Ered Mithrin Campaign Expansion": "Ered Mithrin Hero Expansion",

  // Lord of the Rings Saga — 2 legacy boxes per book → 1 revised saga box
  "The Black Riders": "The Fellowship of the Ring Saga Expansion",
  "The Road Darkens": "The Fellowship of the Ring Saga Expansion",
  "The Treason of Saruman": "The Two Towers Saga Expansion",
  "The Land of Shadow": "The Two Towers Saga Expansion",
  "The Flame of the West": "The Return of the King Saga Expansion",
  "The Mountain of Fire": "The Return of the King Saga Expansion",
};

/** @returns {string|null} Revised product name, or null if this pack has no FFG repackage. */
export function revisedPackLabel(packName) {
  if (packName == null || packName === "") return null;
  return LEGACY_PACK_TO_REVISED[packName] ?? null;
}
